import Styles from './CodeBlock.module.scss';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { nightOwl, githubGist } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Tooltip, IconButton } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const CodeBlock = ({
	t,
	language,
	value,
	isCopyEnabled,
	handleCopy,
	handleCopyDisabled,
	handleCopyButton,
	copied,
	showLineNumbers = true,
	theme = 'dark',
	displayCopyButton = true,
}) => {
	return (
		<>
			<div
				data-testid="codeBlock-codeContainer"
				className={`${theme === 'dark' ? Styles.codeContainer : Styles.codeContainerLight} ${!isCopyEnabled ? Styles.noCopy : ''}`}
				onCopy={(e) => {
					if (!isCopyEnabled) e.preventDefault();
				}}
				onCut={(e) => {
					if (!isCopyEnabled) e.preventDefault();
				}}
				onContextMenu={(e) => {
					if (!isCopyEnabled) e.preventDefault();
				}}
			>
				{displayCopyButton && isCopyEnabled && (
					<div data-testid="codeBlock-codeContainer-copyButtonContainer" id="copyButtonContainer" className={Styles.copyButtonContainer}>
						<Tooltip
							title={
								copied ? t('Labs.Nodes.NodeAutomation.copyCode.copied') : t('Labs.Nodes.NodeAutomation.tooltip.copy')
							}
							arrow
							placement="right"
						>
								<IconButton
									data-testid="codeBlock-codeContainer-copyButton"
									id="copyButton"
									size="small"
									onClick={handleCopyButton}
									sx={{ color: theme === 'dark' ? 'white' : 'black' }}
								>
									{copied ? <DoneAllIcon fontSize="inherit" /> : <ContentCopyIcon fontSize="inherit" />}
								</IconButton>
						</Tooltip>
					</div>
				)}
				<SyntaxHighlighter
					data-testid="codeBlock-codeContainer-highlighter"
					language={language}
					style={theme === 'dark' ? nightOwl : githubGist}
					showLineNumbers={showLineNumbers}
					customStyle={{
						width: '100%',
						borderRadius: '8px',
						overflow: 'auto',
						scrollbarWidth: 'thin',
						WebkitOverflowScrolling: 'touch',
					}}
					onCopy={(e) => {
						!isCopyEnabled ? handleCopyDisabled(e) : handleCopy(e);
					}}
				>
					{value}
				</SyntaxHighlighter>
			</div>
		</>
	);
};
